import { TimeFrameworkFragment } from '../../../__generated__/graphql';
import { mapBreakLegislationRule } from '../mappings';
import { BreakingRulesInfo } from '../shared';
import { orderBy } from 'lodash';

const mapActiveBreakTypesForRequiredBreak = (
  timeFramework: TimeFrameworkFragment,
) => {
  const types = timeFramework.breakTypes ?? [];
  const active = types.filter((bt) => bt.flair__Is_Active__c);
  const sorted = orderBy(
    active,
    [(bt) => bt.flair__Sort_Order__c ?? 0, (bt) => bt.Name.toLowerCase()],
    ['asc', 'asc'],
  );
  return sorted.map((bt) => ({
    name: bt.Name,
    countsTowardRequiredBreak: bt.flair__Counts_Toward_Required_Break__c,
  }));
};

export const mapBreakingRulesInfo = (
  timeFramework: TimeFrameworkFragment,
): BreakingRulesInfo => ({
  minBreakDuration: timeFramework.flair__Minimal_Break_Length__c,
  legislationRules: orderBy(
    timeFramework.breakLegislationRules.map(mapBreakLegislationRule),
    (x) => x.workingTime,
  ),
  deductBreaks: timeFramework.flair__Automatically_Deduct_Unused_Break__c,
  alwaysDeductLegislationBreakLength:
    timeFramework.flair__Always_Deduct_Legislation_Break__c ?? false,
  activeBreakTypesForRequiredBreak:
    mapActiveBreakTypesForRequiredBreak(timeFramework),
});
